/**
 * @generated SignedSource<<4b16906f430fc861035d826c46a09306>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MemoriesCardForgetMutation$variables = {
  id: string;
};
export type MemoriesCardForgetMutation$data = {
  readonly forgetMemory: {
    readonly learner: {
      readonly id: string;
      readonly memories: ReadonlyArray<{
        readonly createdAt: any;
        readonly id: string;
        readonly kind: string;
        readonly text: string;
      }>;
    } | null | undefined;
  };
};
export type MemoriesCardForgetMutation = {
  response: MemoriesCardForgetMutation$data;
  variables: MemoriesCardForgetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ForgetMemoryPayload",
    "kind": "LinkedField",
    "name": "forgetMemory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerMemory",
            "kind": "LinkedField",
            "name": "memories",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MemoriesCardForgetMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "MemoriesCardForgetMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "9c081c64786311835213717b85ff7a95",
    "id": null,
    "metadata": {},
    "name": "MemoriesCardForgetMutation",
    "operationKind": "mutation",
    "text": "mutation MemoriesCardForgetMutation(\n  $id: ID!\n) {\n  forgetMemory(id: $id) {\n    learner {\n      id\n      memories {\n        id\n        kind\n        text\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "73944ac59f8af9c183fd0307d66e8bb5";

export default node;
